import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiUser, FiInfo, FiCheck } = FiIcons;

const expertQA = [
  {
    rank: "Portfolio Strategy",
    question: "Is it a good time to buy gold for my IRA right now?",
    answer: "Gold should be viewed as long-term insurance, not a day-trading asset. Most experts suggest that the best time to buy is whenever you have a retirement balance that is 100% exposed to paper assets. By 'buying the insurance' before the market crash happens, you lock in your protection."
  },
  {
    rank: "Tax Specialist",
    question: "Do I have to pay taxes on the gold when it goes into the IRA?",
    answer: "No. If you follow the direct rollover process, the transfer is tax-deferred. You only pay taxes when you take a distribution in retirement, just like a traditional 401(k) or IRA."
  }
];

const ExpertAnswers = () => {
  return (
    <section className="py-20 bg-slate-100 border-t border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-slate-900 mb-4">Expert Q&A</h2>
          <p className="text-slate-600 max-w-2xl mx-auto">Direct answers from our senior precious metals consultants.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {expertQA.map((item, idx) => (
            <div key={idx} className="bg-white p-8 rounded-2xl shadow-sm border border-slate-200">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-yellow-100 rounded-full flex items-center justify-center">
                  <SafeIcon icon={FiUser} className="text-yellow-600" />
                </div>
                <div>
                  <h4 className="font-bold text-slate-900">{item.rank}</h4>
                  <p className="text-xs text-slate-500 uppercase tracking-wider">Verified Expert</p>
                </div>
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-3 italic">"{item.question}"</h3>
              <p className="text-slate-600 leading-relaxed">{item.answer}</p>
              <div className="mt-6 flex items-center gap-2 text-green-600 text-sm font-medium">
                <SafeIcon icon={FiCheck} />
                <span>IRS Compliant Guidance</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExpertAnswers;